import styled, { css } from 'styled-components';

const CounterButton = styled.div`
    text-align: center;
    background-color: ${({ backgroundColor = '#f4f4f4' }) => css`${backgroundColor}`};
    border-radius: 11.5px;
    cursor: pointer;
    width: ${({ width = 39 }) => `${width}px`};
    ${({ noHover, backgroundColorOnHover = '#969696' }) => !noHover && css`
        &:hover {
            background-color: ${backgroundColorOnHover};
            span {
                color: #fff;
            }
        }
    `}
    ${({ margin = 0, marginHorizontal, marginLeft, marginRight }) => css`
        margin: 0px ${marginRight || marginHorizontal || margin}px 0px ${marginLeft || marginHorizontal || margin}px;
    `}
`;

export default CounterButton;
